import React from 'react';
import Banner from './Banner';
import { Flex, Shimmer } from '@zeal/web-ui';

export default function LayoutSkeleton() {
	return (
		<Flex isColumn className="w-screen h-screen" align="center">
			<Banner />
			<Flex
				isColumn
				className="px-4 py-6 w-full"
				align="center"
				style={{ maxWidth: '375px' }}
			>
				<Flex isColumn gap="6" className="w-full">
					<Flex isColumn gap="4">
						{/* Title */}
						<Shimmer className="w-52" style={{ height: '34px' }} />
						{/* Subitle */}
						<Shimmer className="h-11 w-full" />
					</Flex>
					<Flex isColumn gap="4">
						{/* Input */}
						<Flex isColumn gap="2">
							<Shimmer className="w-24" style={{ height: '22px' }} />
							<Shimmer className="h-12 w-full" />
						</Flex>
						{/* Input */}
						<Flex isColumn gap="2">
							<Shimmer className="w-24" style={{ height: '22px' }} />
							<Shimmer className="h-12 w-full" />
						</Flex>
						{/* Input */}
						<Flex isColumn gap="2">
							<Shimmer className="w-24" style={{ height: '22px' }} />
							<Shimmer className="h-12 w-full" />
						</Flex>
					</Flex>
					{/* Button */}
					<Shimmer className="h-12 w-full" />
				</Flex>
			</Flex>
		</Flex>
	);
}
